<script setup lang="ts">
  import * as changeCase from 'change-case';
  import { onBeforeMount, ref } from 'vue';
  import { useRoute } from 'vue-router';

  import { TaskStatus } from '@stuut/api/models';
  import { ComboSelect } from '@ui/components/combo-select';

  interface Props {
    queryName?: string;
  }

  interface StatusOption {
    label: string;
    value: TaskStatus;
  }

  withDefaults(defineProps<Props>(), {
    queryName: 'status',
  });

  const emit = defineEmits<{
    (e: 'update', value: string[]): void;
  }>();

  const route = useRoute();
  const selectedStatus = ref<StatusOption[]>([]);

  const statusOptions = Object.values(TaskStatus)?.map((status) => ({
    label: changeCase.capitalCase(status),
    value: status,
  }));

  onBeforeMount(() => {
    if (route.query?.status) {
      const statusQuery = route.query.status;
      const statusArray = Array.isArray(statusQuery) ? statusQuery : [statusQuery];

      selectedStatus.value = statusArray
        .map((val) => {
          return statusOptions?.find((option) => option.value === val);
        })
        .filter((option) => option !== undefined) as StatusOption[];
    }
  });

  defineExpose({
    selectedStatus,
  });
</script>

<template>
  <ComboSelect
    v-model="selectedStatus"
    :options="statusOptions"
    searchable
    variant="filter"
    placeholder="Status"
    :multiple="true"
    search-placeholder="Filter by status..."
    option-identifier="label"
    @update:model-value="
      (status) =>
        emit(
          'update',
          Array.isArray(status) ? status?.map((c) => c.value) : status ? [status.value] : [],
        )
    "
  >
    <template #filter-label>
      <i class="fa-regular fa-bars-progress" />
      <span> Status </span>
    </template>
  </ComboSelect>
</template>
